import { /*useLocation,*/ useNavigate } from 'react-router-dom';

export const useGoBack = () => {
  const navigate = useNavigate();
  return ({ fallback }: { fallback?: string }) => navigate(fallback || '/');
};
